import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConsentDataWithCheck } from '../../../types/consent';

const initialState = {
  consents: null as null | ConsentDataWithCheck[],
};

const consentsSlice = createSlice({
  name: 'consents',
  initialState,
  reducers: {
    setConsents(state, { payload }: PayloadAction<ConsentDataWithCheck[]>) {
      state.consents = payload;
    },
    updateConsent(state, { payload }: PayloadAction<{ consentId: string; isChecked: boolean }>) {
      state.consents =
        state.consents?.map((consent) =>
          consent.id === payload.consentId ? { ...consent, isChecked: payload.isChecked } : consent
        ) || null;
    },
  },
});

export const { setConsents, updateConsent } = consentsSlice.actions;
export const consentsReducer = consentsSlice.reducer;
